import { ACCENT } from "../tokens";

export const NAV_LINKS = [
  { href: "#scenarios", label: "Примеры" },
  { href: "#how",       label: "Как это работает" },
  { href: "#features",  label: "Возможности" },
  { href: "#faq",       label: "FAQ" },
];

export const STEPS = [
  {
    n: "01",
    title: "Выбрал что любишь",
    body: "Отметил «мафия, сквош, пляжный волейбол». Только это и будет в ленте. Без книжных клубов и таро-раскладов.",
  },
  {
    n: "02",
    title: "Увидел что собирается",
    body: "Ваша мафия завтра в 19:30, нужен +1 на корт сегодня, пляжный волейбол в воскресенье — всё с временем, местом и сколько уже идёт.",
  },
  {
    n: "03",
    title: "Тапнул «Иду»",
    body: "Один тап — ты в списке. Никаких форм, заявок и «можно ли с вами?».",
  },
  {
    n: "04",
    title: "Списался в чате события",
    body: "Чат события открывается сразу — кто берёт ракетку, где встречаемся. До встречи. После — чат тебе уже не нужен.",
  },
];

export const FOR_WHO = [
  {
    tag:   "Тот самый сценарий",
    title: "Хочешь — но не с кем",
    body:  "Хорошая погода, в голове «надо бы на сквош» — один с женой, второй работает, третий «как-нибудь потом». В итоге сидишь дома. Опять.",
  },
  {
    tag:   "Пять подписок — нулевой результат",
    title: "Знаешь что есть — узнаёшь поздно",
    body:  "Подписан на десяток ивент-страниц — листать лень, реально интересное всплывает уже в сторис «как было». Wychodzi пришлёт уведомление только о том, что твоё.",
  },
  {
    tag:   "Гора чатов в телеге",
    title: "Знаешь куда — лень собирать",
    body:  "Был чат «волейбол сб», был «домики на выходные» — все полумёртвые. Новые не приходят, старые ушли. Создай событие за минуту — соберутся те, кому реально надо.",
  },
];

export const FEATURES = [
  {
    title: "Только твои категории",
    body:  "Отметил «сквош и мафия» — это и видишь. Никакой «йоги-ритрит-таро», если не просил.",
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke={ACCENT} strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
        <path d="M21 4H3M18 12H6M15 20H9"/>
      </svg>
    ),
  },
  {
    title: "Уведомление когда собирается твоё",
    body:  "«Мафия сегодня 19:30, 5/8» — уведомление приходит само. Не нужно заходить в 50 инсташек, чтобы не пропустить.",
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke={ACCENT} strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
        <path d="M18 8a6 6 0 10-12 0c0 7-3 9-3 9h18s-3-2-3-9"/>
        <path d="M13.7 21a2 2 0 01-3.4 0"/>
      </svg>
    ),
  },
  {
    title: "Один тап — ты идёшь",
    body:  "Нажал «Иду» — попал в список и в чат события. Без форм, заявок и «можно ли с вами?».",
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke={ACCENT} strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
        <path d="M9 12l2 2 4-4"/>
        <circle cx="12" cy="12" r="9"/>
      </svg>
    ),
  },
  {
    title: "Создал за 2 минуты",
    body:  "Хочешь своё — выбрал «теннис», поставил время, корт. Wychodzi покажет тем, кто играет в теннис.",
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke={ACCENT} strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
        <rect x="3.5" y="5" width="17" height="15.5" rx="2.5"/>
        <path d="M3.5 10h17M8 3v4M16 3v4M12 14v4M10 16h4"/>
      </svg>
    ),
  },
];

// Replaces fake reviews — these are example event cards as if pulled from the app.
// More honest than fabricated testimonials when the user base is 0 at launch.
export const SCENARIOS = [
  {
    cat:      "sport",
    hue:      "#FF5722",
    title:    "Сквош · сегодня 19:00",
    place:    "Korty Mokotów",
    body:     "Корт забронирован, не хватает 1 партнёра. Уровень — средний, играем час.",
    going:    1,
    cap:      2,
    when:     "Сегодня",
  },
  {
    cat:      "games",
    hue:      "#FFA000",
    title:    "Мафия · завтра 19:30",
    place:    "Hala Koszyki",
    body:     "Ведущий есть. 100 zł за вход, в комплекте напиток. Уже пять, нужны ещё трое.",
    going:    5,
    cap:      8,
    when:     "Завтра",
  },
  {
    cat:      "outdoor",
    hue:      "#10B981",
    title:    "Пляжный волейбол · сб 18:00",
    place:    "Sopot, вход 3",
    body:     "Сетка наша, нужны двое на нашу сторону. Бесплатно. После — пиво.",
    going:    4,
    cap:      6,
    when:     "Суббота",
  },
];

export const FAQS = [
  {
    q: "Это не дейтинг же?",
    a: "Нет. Здесь собираются на сквош, мафию, концерты — не на свидания. Если что-то сложилось романтически — мы не против. Но цель приложения — найти компанию на дело, а не на отношения.",
  },
  {
    q: "Сколько стоит?",
    a: "Само приложение полностью бесплатное. Никаких подписок и комиссий. Платишь только если этого требует событие: корт — пополам, билет на концерт — себе. Wychodzi с этих денег не берёт ни копейки.",
  },
  {
    q: "А если в моём городе никого нет?",
    a: "Скорее всего, так и будет — мы только запускаемся. Wychodzi работает по принципу «кто-то первый»: создай событие, мы покажем его людям с такими же интересами. Через пару недель у тебя уже свой кружок по сквошу.",
  },
  {
    q: "Чем отличается от телеграм-чатов и инсташек?",
    a: "Один чат — на одно событие, живёт, пока живо событие. Не нужно 50 подписок и сотни непрочитанных. Уведомление приходит, когда собирается то, что ты любишь. Без листания, без спама, без «привет всем, я новенький».",
  },
  {
    q: "А вдруг придут странные люди?",
    a: "События публичные, проходят в публичных местах. Видно, кто идёт, есть чат до встречи — можно почитать, как кто пишет. Это как прийти на открытую игру в баре, не пугающе.",
  },
];

export const FOOTER_LINKS = {
  app:      [["https://apps.apple.com/pl/app/wychodzi/id6772133520", "App Store"], ["https://play.google.com/store/apps/details?id=app.wychodzi", "Google Play"]],
  contacts: [["mailto:support@wychodzi.app", "support@wychodzi.app"], ["#", "Instagram"]],
  legal:    [["/privacy", "Политика конфиденциальности"], ["/terms", "Условия использования"]],
};
